<template lang="html">

  <section class="main-view">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper">
        <app-sidebar/>
        <div class="main-panel">
          <div class="content-wrapper">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import AppHeader from '../src/components/partials/AppHeader'
import AppSidebar from '../src/components/partials/AppSidebar'
export default {
  name: 'main',
  components: {
    AppHeader,
    AppSidebar
  }
}
</script>

<style scoped lang="scss">
  .main-view {

  }
</style>



// WEBPACK FOOTER //
// src/mainView.vue